import { render } from "./MainPageView.vue?vue&type=template&id=13c6b736"
import script from "./MainPageView.vue?vue&type=script&lang=js"
export * from "./MainPageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__